import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, InputAdornment, TextField, Button, Alert } from "@mui/material";
import { Visibility, VisibilityOff, ArrowForward } from "@mui/icons-material";

import { postApiCall } from "../../utils/Apicalls";
import "./login.css";
import Header from "../../components/common/header/Header";
import SpinnerShow from "../../components/Spinner";

function LoginScreen() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = React.useState(false);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const userId = localStorage.getItem("userDetails");
    if (userId) {
      navigate("/home");
    }
  }, [navigate]);

  useEffect(() => {
    const userDetails = localStorage.getItem("userDetails");
    const userType = localStorage.getItem("userType");
    if (userDetails && userType === "changePassword") {
      setShowUpdatePasswordModal(true);
    }
  }, []);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = async () => {
    setError("");
    setLoading(true);
    try {
      const result = await postApiCall(`interview-app/auth/login`, {
        email: userName,
        password: password,
      });
      if (result?.status && result?.result && result?.token) {
        localStorage.setItem("userDetails", JSON.stringify(result.result));
        localStorage.setItem("token", result.token);
        
        // Check if userType is changePassword
        if (result.userType === "changePassword") {
          localStorage.setItem("userType", "changePassword");
          setShowUpdatePasswordModal(true);
        } else {
          navigate("home");
        }
      } else {
        setError(result?.message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <>
      <Header />
      <div className="modern-login-container">
        <div className="modern-login-card">
          {loading && (
            <div className="spinner-container">
              <SpinnerShow />
            </div>
          )}
          
          {error && !loading && (
            <div className="login-error-alert">
              <Alert severity="error">{error}</Alert>
            </div>
          )}

          {!loading && (
            <>
              <h2 className="modern-login-title">Login to Your Account</h2>
              
              <form className="modern-login-form" onSubmit={e => { e.preventDefault(); onSubmit(); }}>
                <div className="modern-input-field">
                  <TextField
                    id="email-input"
                    label="Email"
                    variant="outlined"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="Enter your email"
                    fullWidth
                    type="email"
                    required
                  />
                </div>
                
                <div className="modern-input-field">
                  <TextField
                    id="password-input"
                    label="Password"
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                
                <button className="modern-login-button" type="submit">
                  LOG IN NOW
                  <ArrowForward className="arrow-icon" />
                </button>
              </form>
              
              <div className="modern-links-container">
                <div className="account-question-container">
                  <p className="account-question">Don't have an account?</p>
                  <button className="signup-button" onClick={handleSignupClick}>
                    Sign up
                  </button>
                </div>
                <p className="forgot-password" onClick={handleForgotPassword}>
                  Forgot Password?
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      
      {showUpdatePasswordModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h3>Update Password Required</h3>
            </div>
            <div className="modal-content">
              <p>For your security, please update your password now.</p>
            </div>
            <div className="modal-footer">
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => { 
                  setShowUpdatePasswordModal(false); 
                  navigate('/myprofile'); 
                }}
              >
                Update Password
              </Button>
              <Button 
                variant="outlined" 
                onClick={() => {
                  setShowUpdatePasswordModal(false);
                  navigate('/home');
                }}
              >
                Later
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default LoginScreen;
